import { ExternalAccount } from '@/src/common/components/fundingSourceSelector'
import { create } from 'zustand'

export const usePointsToStatementCredit = create<{
  pointsToRedeem: string | undefined
  setPointsToRedeem: (points: string | undefined) => void
  remainingPoints: string | undefined
  setRemainingPoints: (points: string | undefined) => void
  creditAmount: string | undefined
  setCreditAmount: (amount: string | undefined) => void
  conversionRate: string | undefined
  setConversionRate: (rate: string | undefined) => void
  destinationAccount: Partial<ExternalAccount> | undefined
  setDestinationAccount: (account: Partial<ExternalAccount>) => void
  idempotencyKey: string | undefined
  setIdempotencyKey: (key: string | undefined) => void
  clear: () => void
}>((set) => ({
  pointsToRedeem: undefined,
  setPointsToRedeem: (points) => set({ pointsToRedeem: points }),
  remainingPoints: undefined,
  setRemainingPoints: (points) => set({ remainingPoints: points }),
  creditAmount: undefined,
  setCreditAmount: (amount) => set({ creditAmount: amount }),
  conversionRate: undefined,
  setConversionRate: (rate) => set({ conversionRate: rate }),
  destinationAccount: undefined,
  setDestinationAccount: (account) => set({ destinationAccount: account }),
  idempotencyKey: undefined,
  setIdempotencyKey: (key) => set({ idempotencyKey: key }),
  clear: () =>
    set({
      pointsToRedeem: undefined,
      remainingPoints: undefined,
      creditAmount: undefined,
      conversionRate: undefined,
      destinationAccount: undefined,
      idempotencyKey: undefined,
    }),
}))
